import { MainLayout } from "@/layout";
import { retrievePasswordRoute } from "@/config/RouteConfig";

const retrievePassword = {
  path: "",
  component: MainLayout,
  children: [
    {
      ...retrievePasswordRoute,
      component: () => import("@/views/RetrievePassword"),
    },
  ],
};

export default retrievePassword;
